import { f as i } from "./index773.mjs";
import { a as h } from "./index828.mjs";
import { g as c } from "./index873.mjs";
var m = i, a = h, s = c, g = function(o, e, t) {
  var r, n;
  a(o);
  try {
    if (r = s(o, "return"), !r) {
      if (e === "throw")
        throw t;
      return t;
    }
    r = m(r, o);
  } catch (f) {
    n = !0, r = f;
  }
  if (e === "throw")
    throw t;
  if (n)
    throw r;
  return a(r), t;
};
export {
  g as i
};
